module.exports = __webpack_public_path__ + "img/119.3ff5e906.svg";